import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { useAuth } from '../../contexts/AuthContext';

// Mensagem inicial do Dashboard novo (Adnéia, 17/10/2026): aparece UMA vez para cada
// pessoa do atendimento, na primeira vez que abrir o Dashboard novo, com o botão Entendi.
// Espera a boas-vindas do rodízio fechar, para não abrir uma janela por cima da outra.
// A marca de "já viu" fica no navegador (trocar de computador mostra de novo, uma vez).
const VERSAO = 'dashboard-v2-2026-10';

const NovidadesDashboard = () => {
  const { user, isConsulta, isDashboardOnly } = useAuth();
  const [aberto, setAberto] = useState(false);
  const chave = `elo_novidades_${VERSAO}_${user?.email || 'x'}`;

  useEffect(() => {
    if (!user || isConsulta || isDashboardOnly) return;
    let viu = false;
    try { viu = localStorage.getItem(chave) === '1'; } catch { viu = false; }
    if (viu) return;
    let tentativas = 0;
    const t = setInterval(() => {
      tentativas += 1;
      // outra janela aberta (a boas-vindas do rodízio): espera, até 2 minutos
      if (document.querySelector('[role="dialog"]') && tentativas < 60) return;
      clearInterval(t);
      setAberto(true);
    }, 2000);
    return () => clearInterval(t);
  }, [user, isConsulta, isDashboardOnly, chave]);

  const fechar = () => {
    try { localStorage.setItem(chave, '1'); } catch { /* sem localStorage */ }
    setAberto(false);
  };

  const item = (titulo, texto) => (
    <li className="flex gap-2">
      <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-orange-500" />
      <span><strong>{titulo}</strong> {texto}</span>
    </li>
  );

  return (
    <Dialog open={aberto} onOpenChange={(o) => { if (!o) fechar(); }}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-xl">Novidades no Dashboard</DialogTitle>
          <DialogDescription>Bom dia! O Dashboard mudou para deixar o dia mais claro:</DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 text-sm">
          {item('Minhas demandas, no alto da tela:', 'o botão mostra o que você aciona, encerra e confere hoje. Bolinha verde é feito; vermelha, pendente.')}
          {item('Verificação de status:', 'a coluna "O que fazer hoje" diz se é dia de acionar o parceiro, a Camila, a transportadora, o galpão ou o cliente. Os botões montam a lista de cobrança, e o link abre o portal.')}
          {item('Entregue não fica aberto:', 'quem deixou como Entregue, encerra.')}
          {item('Atividades:', 'marque o ✓ todo dia; aparece quem marcou e a hora.')}
          {item('Aba Acessos:', 'o portal e o login de cada canal. A senha continua na planilha por enquanto.')}
          {item('A cor é da pessoa:', 'Caio azul, Gabi laranja.')}
          {item('Sininho:', 'status sem ✓ há 2 dias úteis avisa quem está com ele.')}
        </ul>
        <p className="text-sm border-t pt-3">Qualquer dúvida, me chama. Ad</p>
        <DialogFooter><Button onClick={fechar}>Entendi</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NovidadesDashboard;
